import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import { Application, Login, Xero } from 'containers';
import Loader from 'components/Loader';
import styles from './styles';

class Root extends Component {
  render = () => {
    const { signedIn, loading, provider } = this.props;
    if (loading) {
      return <Loader />;
    } else if (signedIn) {
      if (provider == 'xero') {
        return <Xero />;
      } else {
        return <Application />;
      }
    } else {
      return <Login />;
    }
  }
}

const mapStateToProps = (state) => {
  const signedIn = state.auth.getIn(['user', 'isSignedIn']);
  const provider = state.auth.getIn(['user', 'attributes', 'provider']);
  const loading = state.auth.getIn(['authenticate', 'loading']);
  return { signedIn, loading, provider };
};

const component = connect(mapStateToProps)(Root);
export default withStyles(styles)(component);



// WEBPACK FOOTER //
// ./src/containers/Root/index.js